import { NavigationError } from "@angular/router";

// Chrome, Firefox and Safari wording for a failed dynamic import (esbuild output, no webpack ChunkLoadError)
const CHUNK_LOAD_ERROR_PATTERN =
	/Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/;
const RELOAD_TIMESTAMP_KEY = "chunkLoadErrorReloadAt";
const RELOAD_COOLDOWN_MS = 10_000;

export function isChunkLoadError(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error);
	return CHUNK_LOAD_ERROR_PATTERN.test(message);
}

export function reloadOnChunkLoadError(event: NavigationError) {
	if (!isChunkLoadError(event.error)) {
		return;
	}
	const lastReloadAt = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0);
	// a chunk still missing right after a reload is a real deploy issue: reloading again would loop forever
	if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
		return;
	}
	sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
	window.location.assign(event.url);
}
